import React from 'react';
import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
  Switch,
} from '@roger/ui-components';

interface OverviewSectionProps {
  isAddressed: boolean;
  onChange: (isAddressed: boolean) => void;
}

const OverviewSection: React.FC<OverviewSectionProps> = ({
  isAddressed,
  onChange,
}) => (
  <AccordionItem value='overview' className='border rounded-md px-3'>
    <AccordionTrigger className='text-sm font-medium py-3'>
      Overview
    </AccordionTrigger>
    <AccordionContent className='pb-3 space-y-3'>
      <div className='flex items-center gap-3'>
        <Switch
          checked={isAddressed}
          onCheckedChange={onChange}
          id='is-addressed'
        />
        <label htmlFor='is-addressed' className='text-sm cursor-pointer'>
          This wound was addressed this visit
        </label>
      </div>
      {!isAddressed && (
        <p className='text-sm text-muted-foreground italic'>
          Wound noted as not addressed — additional fields are optional.
        </p>
      )}
    </AccordionContent>
  </AccordionItem>
);

export default OverviewSection;
